/* TPL 2026-10-01: made re-entrant. snippets/share-button.liquid now loads this file
   (share.js extends DetailsDisclosure) and the disabled Dawn header still loads it
   inside the theme editor, so a second evaluation must not redeclare or re-define. */
var DetailsDisclosure = window.DetailsDisclosure || class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
};
window.DetailsDisclosure = DetailsDisclosure;
if (!customElements.get('details-disclosure')) customElements.define('details-disclosure', DetailsDisclosure);

var HeaderMenu = window.HeaderMenu || class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
};
window.HeaderMenu = HeaderMenu;
if (!customElements.get('header-menu')) customElements.define('header-menu', HeaderMenu);
